module.exports = __webpack_public_path__ + "99c923451a72ce4267f93eb0b576e592.png";